import { render, staticRenderFns } from "./contextMenu.vue?vue&type=template&id=31515d10"
import script from "./contextMenu.vue?vue&type=script&lang=js"
export * from "./contextMenu.vue?vue&type=script&lang=js"
import style0 from "./contextMenu.vue?vue&type=style&index=0&id=31515d10&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports